import * as React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../App";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Box
} from "@chakra-ui/core";
import useComponentSize from "../../hook/useComponentSize";
import DateChart from "./DateChart";
export interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default observer(function DateModal({ isOpen, onClose }: Props) {
  const store = useStore();

  return (
    <Drawer size="md" isOpen={isOpen} placement="left" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Dagen</DrawerHeader>

        <DrawerBody overflowY="auto">{isOpen && <Info onClose={onClose} />}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
});

function Info({ onClose }: { onClose: () => void }) {
  const ref = React.useRef<HTMLDivElement>(null);
  const size = useComponentSize(ref);
  const store = useStore();

  return (
    <Box ref={ref}>
      <DateChart
        width={size.width}
        data={store.days.map(d => ({
          name: d.label,
          total: d.total,
          delta: d.delta,
          deaths: d.deaths
        }))}
        onClick={index => {
          store.activeIndex = index;
          onClose();
        }}
      />
    </Box>
  );
}
